// extracted by mini-css-extract-plugin
export default {"container":"ml-z","bubbleNav":"nl-z","graphic":"ol-z","contact":"pl-z"};